/** "BOT" next to a bot's name. Screen readers hear "bot" once, not the letters. */
export function BotTag({ className }: { className?: string }) {
  return (
    <span className={className ? `bot-tag ${className}` : 'bot-tag'}>
      <span aria-hidden="true">BOT</span>
      <span className="sr-only">bot</span>
    </span>
  )
}
